/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Pipe, PipeTransform} from '@angular/core';
import {KeyValue} from '@angular/common';

@Pipe({
    name: 'anyKeyValue',
    standalone: false
})
export class AnyKeyValuePipe implements PipeTransform {

    transform<K, V>(map: Map<K, V>): KeyValue<K, V>[] {
        const final: KeyValue<K, V>[] = [];

        map.forEach((value, key) => {
            final.push({
                key,
                value
            });
        });

        return final;
    }

}
